import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link, { LinkProps } from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import useReactRouterBreadcrumbs, { BreadcrumbMatch } from "use-react-router-breadcrumbs";
import { Grid } from "@mui/material";
import { MdmBreadcrumbsRoutes } from "./MdmBreadcrumbsRoutes";
import { isLastIndexOf } from "../../Utils/arrays";

interface BreadCrumbElementProps extends LinkProps {
  match: BreadcrumbMatch;
  noLink: boolean;
}

function BreadcrumbElement({ match, noLink, children }: BreadCrumbElementProps) {
  return noLink ? (
    <div>{children}</div>
  ) : (
    <Link underline="hover" color="inherit" to={match.pathname} component={RouterLink}>
      {children}
    </Link>
  );
}

export default function MdmBreadcrumbs() {
  const crumbsMap = useReactRouterBreadcrumbs(MdmBreadcrumbsRoutes);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Breadcrumbs aria-label="breadcrumb" maxItems={4} sx={{ color: "#000000E6" }}>
          {crumbsMap.map(({ match, breadcrumb }, index) => (
            <BreadcrumbElement
              key={match.pathname}
              match={match}
              noLink={isLastIndexOf(crumbsMap, index) || !!match.route?.props?.noLink}
            >
              {breadcrumb}
            </BreadcrumbElement>
          ))}
        </Breadcrumbs>
      </Grid>
    </Grid>
  );
}
